export default {
  small: '320',
  medium: '600',
  xmedium: '800',
  large: '1000',
  xlarge: '1400',
  xxlarge: '1800',
};
